// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, CadastroAutorizacaoEspecialRequest } from './types';

export function cadastroAutorizacaoEspecialRequest(
	token: string,
	payload: CadastroAutorizacaoEspecialRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_AUTORIZACAO_ESPECIAL_REQUEST,
		token,
		payload,
	};
}
export function cadastroAutorizacaoEspecialSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_AUTORIZACAO_ESPECIAL_SUCCESS,
		payload,
	};
}
export function cadastroAutorizacaoEspecialFailure(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_AUTORIZACAO_ESPECIAL_FAILURE,
		payload: null,
	};
}

export function cadastroAutorizacaoEspecialClear(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_AUTORIZACAO_ESPECIAL_CLEAR,
		payload: null,
	};
}
